<template>
  <div class="page-table">
    <div class="no-print">
      <a-form :form="searchForm" @submit="handleSearch">
        <div class="page-search">
          <a-row>
            <a-col :span="6">
              <a-form-item label="报修人类型" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-select
                  allowClear
                  :options="bxrlxOptions"
                  placeholder="报修人类型"
                  v-decorator="['f_eq_dllx',
                  {
                    rules:[
                      { required: false,message: '请选择报修人类型！'}
                    ]
                  }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="报修人" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-input v-decorator="['f_like_bxjl__xm']"  placeholder="请输入" maxlength="10" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="报修单号" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-input v-decorator="['f_like_bxdh']" placeholder="请输入" maxlength="16" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="手机号" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-input v-decorator="['f_like_sjh']" placeholder="请输入" maxlength="11" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6">
              <a-form-item label="报修日期" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-range-picker
                  style="width: 100%"
                  v-decorator="['pickerdate']"
                  @change="onpickerChange"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="故障描述" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-input v-decorator="['f_like_gzms']" placeholder="请输入" maxlength="100" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="报修类型" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-select allowClear placeholder="报修类型" v-decorator="['bxlx']">
                  <a-select-option
                    v-for="bxlxOptions in bxlxOptions"
                    :key="bxlxOptions.id"
                  >{{bxlxOptions.mc}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="维修员" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-input v-decorator="['f_like_wxryXm']" placeholder="请输入" maxlength="10" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6">
              <a-form-item label="报修校区" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-select
                  allowClear
                  :options="bxxqOptions"
                  placeholder="全部校区"
                  v-decorator="['f_eq_bxjl__xqdm']"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="楼宇名称" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-input v-decorator="['f_like_jz__lymc']" placeholder="请输入" maxlength="10" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="区域房间号" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-input v-decorator="['f_like_qy__qyfjh']" placeholder="请输入" maxlength="10" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="耗材登记" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-select
                  allowClear
                  :options="djhcOptions"
                  placeholder="是否登记耗材"
                  v-decorator="['sfdjhc']"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6">
              <a-form-item label="零星工程" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                <a-select allowClear placeholder="是否零星工程" v-decorator="['sfzlxbx']">
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="10"></a-col>
            <a-col :span="14" class="search-btns" style="line-height: 39px;text-align:right;">
              <a-button style="margin-right:20px" type="primary" @click="toApply">我要报修</a-button>
              <a-button style="margin-right:20px" type="primary" html-type="submit">查询</a-button>
              <a-button style="margin-right:20px" type="primary" @click="exportExcel">导出</a-button>
              <a-button type="primary" @click="printIng">打印</a-button>
            </a-col>
          </a-row>
        </div>
        <div class="table-operator">
          <a-row style="text-align:left;padding: 10px 0;">
            <a-col
              v-for="(typeData, index) in typeData"
              :key="index"
              class="search-btns"
              style="margin-right:1%;line-height: 39px;display:inline-block;"
            >
              <a-button
                :class="{active:typeData.text === topNavactive}"
                @click="handleSearchmore (typeData)"
              >{{typeData.value}}</a-button>
              <!-- html-type="submit" -->
            </a-col>
          </a-row>
          <!-- 表格 -->
          <standard-table
            rowKey="key"
            showRowSelection
            :columns="columns"
            :pagination="PAGINATION"
            :dataSource="dataSource"
            @change="onChange"
            @rowChange="onRowChange"
          />
        </div>
      </a-form>
      <!-- 查看、修改弹框 -->
      <a-modal
        destroyOnClose
        :maskClosable="false"
        width="800px"
        :title="`${ enableedit ? '查看' : '修改' }报修单`"
        v-model="visible"
        @ok="handleSubmit"
      >
        <a-form :form="form">
          <a-row style="padding-left:3.5%">
            <a-col :span="10" style="padding-right: 20px;">
              <a-form-item label="报修地点" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <!-- 校区 -->
                <a-select
                  :disabled="enableedit"
                  v-decorator="['xqdm',
                  {rules: [{ required: true, message: '请选择校区!' }]}
                ]"
                  @change="handleSchoolChange"
                >
                  <a-select-option
                    v-for="schoolData in schoolData"
                    :key="schoolData.value"
                  >{{schoolData.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 宿舍楼 -->
            <a-col :span="7" style="padding-right: 20px;">
              <a-form-item>
                <a-select
                  :disabled="enableedit"
                  v-decorator="['lyId',
                  {rules: [{ required: true, message: '请选择宿舍楼!' }]}
                ]"
                  @change="handleBuildChange"
                >
                  <a-select-option
                    v-for="buildData in buildData"
                    :key="buildData.id"
                  >{{buildData.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 房间号 -->
            <a-col :span="7" style="padding-right: 20px;">
              <a-form-item>
                <a-select
                  :disabled="enableedit"
                  v-decorator="['qyfjh',
                  {rules: [{ required: true, message: '请选择房间号!' }]}
                ]"
                >
                  <a-select-option v-for="roomData in roomData" :key="roomData.id">{{roomData.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item
            label="详细地址"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 20}"
            style="padding-right: 20px;"
          >
            <!-- { pattern: /^[\s\S]{2,50}$/, message: '请输入2-50位！' } -->
            <a-input
              :disabled="enableedit"
              v-decorator="[
              'xxdz',
              {
                rules: [
                  { required: true, message: '请输入详细地址！' }
                ]
              }
            ]"
              placeholder="请输入详细地址"
              maxlength="50"
            />
          </a-form-item>
          <a-form-item
            label="报修人姓名"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 20}"
            style="padding-right: 20px;"
          >
            <span>{{username}}</span>
          </a-form-item>
          <a-form-item
            :disabled="enableedit"
            label="手机号"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 20}"
            style="padding-right: 20px;"
          >
            <a-input
              :disabled="enableedit"
              v-decorator="[
              'sjh',
              {
                rules: [
                  { required: true, message: '请输入手机号！' },
                  { pattern: /^1\d{10}$/, message: '请输入正确的格式！' }
                ]
              }
            ]"
              placeholder="请输入手机号"
              maxlength="11"
            />
          </a-form-item>
          <a-form-item label="报修类型" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
            <!-- 报修类型 -->
            <a-col :span="8" style="padding-right: 20px;">
              <a-select
                v-decorator="['bxlx',
                {rules: [{ required: true, message: '请至少选择一级报修类型!' }]}
              ]"
                :disabled="enableedit"
                @change="handletypeChange"
              >
                <a-select-option v-for="otypeData in otypeData" :key="otypeData.id">{{otypeData.mc}}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8" style="padding-right: 20px;">
              <a-select
                :disabled="enableedit"
                v-model="typetwoDatamod"
                @change="handletypetwoChange"
              >
                <a-select-option
                  v-for="typetwoData in typetwoData"
                  :key="typetwoData.id"
                >{{typetwoData.mc}}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8" style="padding-right: 20px;">
              <a-select :disabled="enableedit" v-model="typethirDatamod">
                <a-select-option
                  v-for="typethirData in typethirData"
                  :key="typethirData.id"
                >{{typethirData.mc}}</a-select-option>
              </a-select>
            </a-col>
          </a-form-item>
          <a-form-item
            label="故障描述"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 20}"
            style="padding-right: 20px;"
          >
            <!-- { pattern: /^[\s\S]{2,10}$/, message: '请输入2-10位！' } -->
            <a-textarea
              :disabled="enableedit"
              :rows="3"
              v-decorator="[
              'gzms',
              {
                rules: [
                  { required: true, message: '请输入故障描述！' }
                ]
              }
            ]"
              placeholder="请输入故障描述"
              maxlength="200"
            />
          </a-form-item>
          <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 20}" style="padding-right: 20px;">
            <div slot="label">上传故障图片（最多上传10张）</div>
            <upload-picture
              action="/api/file/upload.do"
              :seenote="enableedit"
              v-decorator="['imgUrl']"
            />
          </a-form-item>
          <!-- <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 20}">
            <div slot="label">维修时间特殊要求（可不填）</div>
            <a-col :span="8" style="padding-right: 20px;">
              <a-select allowClear :disabled="enableedit" v-model="timestartmod">
                <a-select-option
                  v-for="timestart in timestart"
                  :key="timestart.value"
                >{{timestart.label}}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8" style="padding-right: 20px;">
              <a-select allowClear :disabled="enableedit" v-model="timeendmod">
                <a-select-option v-for="timeend in timeend" :key="timeend.value">{{timeend.label}}</a-select-option>
              </a-select>
            </a-col>
          </a-form-item> -->
          <a-form-item
            label="备注"
            :labelCol="{span: 4}"
            v-if="bxbzList.length > 0"
            :wrapperCol="{span: 20}"
            style="padding-right: 20px;"
          >
            <p v-for="(bxbzList,index) in bxbzList" :key="index">{{bxbzList.bz}}</p>
          </a-form-item>
          <a-form-item v-if="serviceModel">
            <p style="font-size: 16px;text-align: center;font-weight: bold;">评价信息</p>
          </a-form-item>
          <a-form-item
            v-if="serviceModel"
            label="完成情况"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 20}"
          >
            <div class="table-operators">
              <a-button
                disabled
                :class="{'a-button-selected':complete==='1'}"
                style="margin-right:20px"
              >已完成</a-button>
              <a-button disabled :class="{'a-button-selected':complete==='0'}">未完成</a-button>
            </div>
          </a-form-item>
          <a-form-item
            v-if="serviceModel && complete === '1'"
            label="服务评价"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 20}"
          >
            <a-radio-group disabled name="radioGroup" :defaultValue="fwpjradio">
              <a-radio value="1">非常满意</a-radio>
              <a-radio value="2">满意</a-radio>
              <a-radio value="3">一般</a-radio>
              <a-radio value="4">不满意</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            v-if="serviceModel"
            label="意见反馈"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 20}"
          >
            <a-textarea
              disabled
              v-decorator="[
              'yjfk',
              {
                rules:[
                  { required: false,message: '反馈意见不能为空！'}
                ]
              }
            ]"
              placeholder="请写下您的反馈意见"
              maxlength="10"
            />
          </a-form-item>
          <div v-if="enableedit" class="mydiyfooter">
            <a-button @click="cleanform()" type="primary">确定</a-button>
          </div>
        </a-form>
      </a-modal>
      <!-- 结单弹框 -->
      <a-modal
        destroyOnClose
        :maskClosable="false"
        :title="formtitle"
        v-model="overVisible"
        @ok="handleDescription"
      >
        <a-form :form="overform">
          <a-form-item
            v-if="auditResultVisible"
            label="审核结果"
            :labelCol="{span: 5}"
            :wrapperCol="{span: 18}"
          >
            <a-radio-group @change="onShjgChange" name="radioGroup" :defaultValue="shjgradio">
              <a-radio value="1">通过</a-radio>
              <a-radio value="2">不通过</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="说明" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
            <a-textarea v-decorator="['sm']" placeholder="添加说明（不超过50字）" maxlength="50" />
          </a-form-item>
          <a-form-item v-if="uploadPicVisible" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
            <span slot="label">
              上传图片
              <br />（最多10张）
            </span>
            <upload-picture
              action="/api/file/upload.do"
              :seenote="enableedit"
              v-decorator="['imgUrl']"
            />
          </a-form-item>
        </a-form>
      </a-modal>
      <!-- 延单审核 -->
      <a-modal
        destroyOnClose
        :maskClosable="false"
        title="延单审核"
        v-model="DelayVisible"
        @ok="handleDelay()"
      >
        <a-form :form="Delayform">
          <div class="title-border-left">延单申请</div>
          <a-form-item
            label="延单类型"
            :labelCol="{span: 5}"
            :wrapperCol="{span: 18}"
          >
            <a-input disabled v-model="ydinfo.ydlx" ></a-input>
          </a-form-item>
          <a-form-item
            label="延单时间"
            :labelCol="{span: 5}"
            :wrapperCol="{span: 18}"
          >
            <a-input disabled v-model="ydinfo.ydsj" ></a-input>
          </a-form-item>
          <a-form-item
            label="延单理由"
            :labelCol="{span: 5}"
            :wrapperCol="{span: 18}"
          >
            <a-input disabled v-model="ydinfo.ydly" ></a-input>
          </a-form-item>
          <div class="title-border-left">审核</div>
          <a-form-item
            label="是否转办"
            :labelCol="{span: 5}"
            :wrapperCol="{span: 18}"
          >
            <a-radio-group v-decorator="['sfzb',
              {
                rules: [
                  { required: true, message: '请选择是否转办！' }
                ]
              }
              ]" @change="zhChange">
              <a-radio value="0">否</a-radio>
              <a-radio value="1">是</a-radio>
            </a-radio-group>
          </a-form-item>
          <template v-if="sfzbvalue === '0'">
            <a-form-item
              label="审核结果"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18}"
            >
              <a-radio-group v-decorator="['shjg',
                {
                  rules: [
                    { required: true, message: '请选择审核结果！' }
                  ]
                }
                ]">
                <a-radio value="1">通过</a-radio>
                <a-radio value="0">不通过</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="审核说明" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
              <a-textarea v-decorator="['sm']" placeholder="添加说明（不超过50字）" maxlength="50" />
            </a-form-item>
          </template>
        </a-form>
      </a-modal>
      <!-- 结单 -->
      <a-modal
        destroyOnClose
        :maskClosable="false"
        title="结单"
        v-model="transferVisiable"
        @ok="handletransfer()"
      >
        <a-form :form="transferform">
          <div class="title-border-left">处理</div>
          <a-form-item
            label="处理人员"
            :labelCol="{span: 5}"
            :wrapperCol="{span: 18}"
          >
            <a-select :options="wxryOptions" placeholder="请选择" v-decorator="['wxry',
            {
              rules: [
                { required: true, message: '请选择处理人员！' }
              ]
            }]"/>
          </a-form-item>
          <a-form-item label="维修描述" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
            <a-textarea v-decorator="['sm']" placeholder="维修描述（不超过200字）" maxlength="200" />
          </a-form-item>
          <div class="title-border-left">耗材登记<span style="font-weight:normal;font-size: 14px;margin-left: 10px;color:red">（如无耗材则无需登记）</span></div>
          <a-row v-for="(hcdjlist, index) in hcdjlist" :key="index">
            <a-col :span="12" style="padding-left:20px">
              <a-form-item>
                <a-select
                  allowClear
                  showSearch
                  placeholder="请输入耗材名称！"
                  style="width:100%"
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @mouseenter="handleFocus(`${index}`)"
                  @search="handleSearchSelect2"
                  :notFoundContent="null"
                  v-decorator="[`hcdjlist[${index}].hcId`]"
                  maxlength="20"
                >
                  <a-select-option v-for="d in data" :key="d.id">{{d.mc}}({{d.gg}})</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" style="padding-left:20px">
              <a-form-item>
                <a-input
                  v-decorator="[
                  `hcdjlist[${index}].hfsl`,
                  {
                    rules: [
                      // { required: true, message: '请输入数量！' },
                      { pattern: /^(0|([1-9]\d{0,2}))$/, message: '请输入正确的数量！' }
                    ]
                  }
                ]"
                  type="text"
                  placeholder="数量"
                  maxlength="3"
                />
              </a-form-item>
            </a-col>
            <a-col class="addanddel" :span="6" style="padding-left:20px">
              <a-button @click="addList" type="primary" shape="circle" icon="plus"></a-button>
              <a-button @click="delList(index)" type="danger" shape="circle" icon="minus"></a-button>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <!-- 转为零星报修弹框 -->
      <a-modal
        destroyOnClose
        :maskClosable="false"
        title="转为零星报修"
        v-model="lxbxVisible"
        @ok="handleLxbxSubmit"
      >
        <a-form :form="lxbxform">
          <a-form-item label="供应商" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
            <a-select
              showSearch
              allowClear
              placeholder="请选择供应商"
              :filterOption="filterGys"
              v-decorator="['gysId',
              {
                rules: [
                  { required: true, message: '请选择供应商！' }
                ]
              }]"
            >
              <a-select-option v-for="item in gysList" :key="item.id" :value="item.id">{{item.gysName}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-modal>
      <!-- 指派人员弹框 -->
      <a-modal
        destroyOnClose
        :maskClosable="false"
        :title="`指派人员`"
        v-model="assignVisible"
        @ok="handleAssignption"
      >
        <a-form :form="assignform">
          <a-form-item>
            <a-col :span="18">
              <a-input v-model="searchzprxm" placeholder="输入人员姓名" maxlength="50" />
            </a-col>
            <a-col :span="2"></a-col>
            <a-col :span="4">
              <a-button @click="zprysearch" type="primary">查询</a-button>
            </a-col>
          </a-form-item>
        </a-form>
        <!-- 展示 -->
        <div v-if="!zprxm || zprxm === ''">
          <ul class="zprlistul">
            <li style="text-align:center;font-weight:bold;margin-bottom:10px">
              <a-row>
                <a-col :span="18">人员属性</a-col>
                <a-col :span="6">未完成报修单数</a-col>
              </a-row>
            </li>
            <li
              v-for="(tjList,index) in perdatasource.tjList"
              :key="index"
              :class="{active:index === isActive}"
              @click="chosewxy(tjList,index,1)"
            >
              {{index+1}} {{tjList.XM}} {{tjList.SJHM}} {{tjList.XQMC}} {{tjList.WXLX}}
              <a
                @click="jumptodetail(tjList)"
              >{{tjList.WWCBXDS || 0}}</a>
            </li>
            <li class="notice">系统推荐维修员</li>
            <li
              v-for="(mrList,ind) in perdatasource.mrList"
              :key="ind"
              :class="{active:ind === isActivetwo}"
              @click="chosewxy(mrList,ind,2)"
            >
              {{ind+1}} {{mrList.XM}} {{mrList.SJHM}} {{mrList.XQMC}} {{mrList.WXLX}}
              <a
                @click="jumptodetail(mrList)"
              >{{mrList.WWCBXDS || 0}}</a>
            </li>
            <li class="notice">其他维修员</li>
          </ul>
        </div>
        <!-- 搜索 -->
        <div v-if="zprxm && zprxm !== ''">
          <ul class="zprlistul">
            <li
              v-for="(tjList,index) in perdatasource.tjList"
              :key="index"
              :class="{active:index === isActive}"
              @click="chosewxy(tjList,index,1)"
            >
              {{index+1}} {{tjList.XM}}{{tjList.SJHM}}{{tjList.XQMC}}{{tjList.WXLX}}
              <a
                @click="jumptodetail(tjList)"
              >{{tjList.WWCBXDS || 0}}</a>
            </li>
          </ul>
        </div>
      </a-modal>
      <!-- 查看流程弹框 -->
      <a-modal
        class="lcmodal"
        destroyOnClose
        :maskClosable="false"
        :title="`流程说明`"
        v-model="visibleprease"
        :footer="null"
      >
        <p style="font-size: 16px;color: #3094f9">
          报修单号：{{bxdh}}
          <span style="float: right;">{{currentRowStatusText}}</span>
        </p>
        <div v-for="(lcData,index) in preaseData.list" :key="index">
          <p>{{index+1}}、{{lcData.clms}}</p>
          <div class="smdiv" v-if="lcData.sm">
            <p>&nbsp;&nbsp;说明:{{lcData.sm}}</p>
          </div>
          <div class="lcpicdiv" v-if="lcData.picList && lcData.picList != []">
            <img v-for="(piclist,index) in lcData.picList" :key="index" :src="piclist.fileFullName" />
          </div>
          {{lcData.createDate}}
        </div>
        <a-form v-if="preaseData.yqList && preaseData.yqList.length > 0">
          <a-form-item
            style="margin-top:10px;"
            label="延单说明"
            :labelCol="{span: 4}"
            :wrapperCol="{span: 20}"
          >
            <div style="line-height:1.5" v-for="(preaseData,ind) in preaseData.yqList" :key="ind">
              <p>{{preaseData.bz}}</p>
              {{preaseData.createDate}}
            </div>
          </a-form-item>
        </a-form>
        <div class="mydiyfooter">
          <a-button @click="handleSubmitprease" type="primary">确定</a-button>
        </div>
      </a-modal>
      <!-- 耗材登记弹框 -->
      <a-modal
        destroyOnClose
        :maskClosable="false"
        :title="`耗材登记`"
        v-model="usedVisible"
        width="800px"
        :footer="null"
      >
        <!-- @ok="handleusedption" -->
        <!-- <a-row> -->
        <!-- 报修单号：{{}} 维修人员：{{}} -->
        <!-- </a-row> -->
        <a-form :form="usedform">
          <a-row v-for="(hcdjlist, index) in hcdjlist" :key="index">
            <a-col :span="7">
              <a-form-item>
                <a-select
                  :disabled="hcenabel"
                  @change="handleChangeXq(`${index}`)"
                  v-decorator="[`hcdjlist[${index}].xqdm`,
                {rules: [
                    { required: true, message: '请选择校区！' }
                  ]}
                ]"
                  placeholder="请选择校区"
                >
                  <a-select-option
                    v-for="schoolData in schoolData"
                    :key="schoolData.value"
                  >{{schoolData.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="7" style="padding-left:20px">
              <a-form-item>
                <a-select
                  :disabled="hcenabel"
                  allowClear
                  showSearch
                  placeholder="请输入耗材名称！"
                  style="width:100%"
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @mouseenter="handleFocus(`${index}`)"
                  @change="handleChange"
                  @search="handleSearchSelect"
                  :notFoundContent="null"
                  v-decorator="[`hcdjlist[${index}].hcId`,
                {rules: [
                    { required: true, message: '请输入耗材名称！' }
                  ]}
                ]"
                  maxlength="20"
                >
                  <a-select-option v-for="d in data" :key="d.id">{{d.mc}}({{d.gg}})</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5" style="padding-left:20px">
              <a-form-item>
                <a-input
                  :disabled="hcenabel"
                  v-decorator="[
                  `hcdjlist[${index}].hfsl`,
                  {
                    rules: [
                      { required: true, message: '请输入数量！' },
                      { pattern: /^(0|([1-9]\d{0,2}))$/, message: '请输入正确的数量！' }
                    ]
                  }
                ]"
                  type="text"
                  placeholder="数量"
                  maxlength="3"
                />
              </a-form-item>
            </a-col>
            <a-col v-if="hcenabel === false" class="addanddel" :span="4" style="padding-left:20px">
              <a-button @click="addList" type="primary" shape="circle" icon="plus"></a-button>
              <a-button @click="delList(index)" type="danger" shape="circle" icon="minus"></a-button>
            </a-col>
          </a-row>
        </a-form>
        <div v-if="hcenabel === false" class="mydiyfooter">
          <a-button @click="canelusedption">取消</a-button>
          <a-button @click="handleusedption(1)" type="primary">提交</a-button>
          <a-button @click="handleusedption(2)" type="primary">保存</a-button>
        </div>
        <div v-if="hcenabel" class="mydiyfooter">
          <a-button @click="canelusedption" type="primary">确定</a-button>
        </div>
      </a-modal>
    </div>
    <div class="print-area print">
      <div class="table-operator grid-table">
        <div
          class="table-inline"
          v-for="(Print , num) in dataSourcePrint"
          :key="num"
          :class="num%2===0 ? 'left' : 'right'"
        >
          <table>
            <tr>
              <td colspan="4">派工单</td>
            </tr>
            <tr>
              <td>报修单号</td>
              <th>{{Print.bxdh}}</th>
              <td>报修人</td>
              <th>{{Print.xm}}</th>
            </tr>
            <tr>
              <td>报修人电话</td>
              <th>{{Print.sjh}}</th>
              <td>报修时间</td>
              <th>{{Print.createDate}}</th>
            </tr>
            <tr>
              <td>报修地址</td>
              <th>{{Print.xxdz}}</th>
              <td>报修类型</td>
              <th>{{Print.bxlx}}</th>
            </tr>
            <tr>
              <td>维修人员</td>
              <th colspan="3">{{Print.wxryXm}}</th>
            </tr>
            <tr>
              <td>维修时间要求</td>
              <th colspan="3">{{Print.kssj}} - {{Print.jssj}}</th>
            </tr>
            <tr>
              <td>故障描述</td>
              <th colspan="3">{{Print.gzms}}</th>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { TreeSelect } from 'ant-design-vue'
import UploadPicture from '../../components/upload/UploadPicture'
import unget from '../../assets/png/unget.png'
import dealing from '../../assets/png/dealing.png'
import unsure from '../../assets/png/unsure.png'
import finish from '../../assets/png/finish.png'
import examine from '../../assets/png/examine.png'
import broken from '../../assets/png/broken.png'
import todeal from '../../assets/png/todeal.png'
import inclu from '../../assets/png/inclu.png'
import delayed from '../../assets/png/delayed.png'
import hasclan from '../../assets/png/hasclan.png'
let timeout
let timeoutTwo
let currentValue
const env = process.env.NODE_ENV
const SHOW_PARENT = TreeSelect.SHOW_PARENT
export default {
  name: 'QueryList',
  components: {
    UploadPicture
  },
  data () {
    const query = this.$route.query
    const columns = [
      {
        title: '报修单号',
        align: 'center',
        width: 125,
        dataIndex: 'bxdh'
      },
      {
        title: '报修类型',
        align: 'center',
        dataIndex: 'bxlx'
      },
      // 报修来源
      {
        title: '报修来源',
        align: 'center',
        dataIndex: 'fwly'
      },
      {
        title: '报修人',
        align: 'center',
        dataIndex: 'xm'
      },
      {
        title: '手机号',
        align: 'center',
        width: 130,
        dataIndex: 'sjh'
      },
      {
        title: '报修地点',
        align: 'center',
        dataIndex: 'xxdz'
      },
      {
        title: '故障描述',
        align: 'center',
        dataIndex: 'gzms'
      },
      {
        title: '维修员',
        align: 'center',
        dataIndex: 'wxryXm'
      },
      {
        title: '状态',
        align: 'center',
        width: '140px',
        customRender: (text, record, index) => {
          let displayText = {}
          if (text.dqzt === '1') {
            displayText.text = '未接单'
            displayText.pointsrc = unget
          } else if (text.dqzt === '2') {
            displayText.text = '处理中'
            displayText.pointsrc = dealing
          } else if (text.dqzt === '3') {
            displayText.text = '待确认'
            displayText.pointsrc = unsure
          } else if (text.dqzt === '4') {
            displayText.text = '维修完成'
            displayText.pointsrc = finish
          } else if (text.dqzt === '5') {
            displayText.text = '已取消'
            displayText.pointsrc = hasclan
          } else if (text.dqzt === '6') {
            displayText.text = '废单审核中'
            displayText.pointsrc = examine
          } else if (text.dqzt === '7') {
            displayText.text = '已废单'
            displayText.pointsrc = broken
          } else if (text.dqzt === '9') {
            displayText.text = '待处理'
            displayText.pointsrc = todeal
          } else if (text.dqzt === '10') {
            displayText.text = '已登记耗材'
            displayText.pointsrc = inclu
          } else if (text.dqzt === '11') {
            displayText.text = '延单审核中'
            displayText.pointsrc = inclu
          } else if (text.dqzt === '8') {
            displayText.text = '已延单'
            displayText.pointsrc = inclu
          }
          displayText.yspicsrc = delayed

          this.currentRowStatusText = displayText.text
          this.bxdh = record.bxdh
          var html = (
            <div class="alink">
              <img src={displayText.pointsrc} />
              <a href="javascript:" onClick={() => this.showFlowlabel(true, record, displayText.text)}>{displayText.text}</a>
            </div>
          )
          if (text.yqbz === '0') {
            // 已延单 加延单标识
            html = (
              <div class="alink">
                <img src={displayText.pointsrc} />
                <a href="javascript:" onClick={() => this.showFlowlabel(true, record, displayText.text)}>{displayText.text}</a>
                <img class="delayed" src={displayText.yspicsrc} />
              </div>
            )
          }
          return html
        }
      },
      // 是否登记耗材
      {
        title: '是否登记耗材',
        align: 'center',
        dataIndex: 'sfdjhc',
        customRender: (text, record, index) => {
          return record.sfdjhc === '1' ? '是' : '否'
        }
      },
      {
        title: '报修时间',
        align: 'center',
        width: '140px',
        dataIndex: 'createDate'
      },
      {
        title: '操作',
        align: 'center',
        fixed: 'right',
        width: '90px',
        customRender: (text, record, index) => {
          var html
          // var operTypeHtml = this.operTypeHtml
          var roleCode = this.roleCode
          // dqzt: 订单状态 : 1、未完成 2、处理中 3、待确认 4、维修完成 5、已取消 6、废单审核 7、已废单 8、已延单 9、待处理 10、已登记耗材 11、延单审核中 12、已转办
          // cjwc: 曾经完成: 1是 0否
          html = (
            <div class="row-operator">
              <a class="btnmore" href="javascript:;">...
                <div class="czbtns">
                  <div class="santop"></div>
                  <div class="czdiv">
                    <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
                    {(record.dqzt === '1' && record.cjwc !== '1') && <div><a href="javascript:;" onClick={() => this.showModal(true, record, 2)}>修改</a></div>}
                    {record.dqzt === '1' && <div><a href="javascript:;" class="red" onClick={() => this.handleperDialog(true, record)}>指派人员</a></div>}
                    {((record.dqzt === '1' && record.cjwc === '1') || record.dqzt === '9' || record.dqzt === '2' || record.dqzt === '11' || record.dqzt === '8') && <div><a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 3, '退回')}>退回</a></div>}
                    {(record.dqzt === '1' || record.dqzt === '9' || record.dqzt === '2' || record.dqzt === '11' || record.dqzt === '8') && <div><a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 2, '废单')}>废单</a></div>}
                    {(record.dqzt === '1') && <div><a href="javascript:;" onClick={() => this.showInputTextModal(true, record, 10, '备注')}>备注</a></div>}
                    {(record.dqzt === '9') && <div><a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 5, '接单')}>接单</a></div>}
                    {((record.dqzt === '2' || record.dqzt === '11' || record.dqzt === '8') && record.sfzb === '0') && <div><a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 6, '结单')}>结单</a></div>}
                    {((record.dqzt === '2' || record.dqzt === '11' || record.dqzt === '8') && record.sfzb === '1') && <div><a href="javascript:;" class="red" onClick={() => this.transferModal(record)}>结单</a></div>}
                    {(record.dqzt === '9' || record.dqzt === '2') && <div><a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 4, '撤回')}>撤回</a></div>}
                    {record.dqzt === '2' && <div><a href="javascript:;" onClick={() => this.showInputTextModal(true, record, 9, '延单')}>延单</a></div>}
                    {(record.dqzt === '2' && record.sfzlxbx !== '1') && <div><a href="javascript:;" class="red" onClick={() => this.handleToLxbx(record)}>转为零星报修</a></div>}
                    {(record.dqzt === '4' && record.sfdjhc !== '1') && <div><a href="javascript:;" class="red" onClick={() => this.handleMaterialRegister(record, 1)}>耗材登记</a></div>}
                    {((record.dqzt === '3' || record.dqzt === '4') && record.sfdjhc === '1') && <div><a href="javascript:;" class="red" onClick={() => this.handleMaterialRegister(record, 2)}>查看耗材</a></div>}
                    {(record.dqzt === '6') && <div><a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 11, '废单审核')}>审核</a></div>}
                    {(record.dqzt === '11') && <div><a href="javascript:;" class="red" onClick={() => this.delayModal(record)}>审核</a></div>}
                  </div>
                </div>
              </a>
            </div>
          )

          // if (roleCode === 'BXXT_PDY') {
          //   // 派单员
          //   if (record.dqzt === '1') {
          //   // 未接单
          // if (record.cjwc === '1') {
          // // 曾经完成
          //   html = (
          //         <div class="row-operator">
          //           <a class="btnmore" href="javascript:;">...
          //             <div class="czbtns">
          //               <div class="santop"></div>
          //               <div class="czdiv">
          //                 <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //                 <a href="javascript:;" class="red" onClick={() => this.handleperDialog(true, record)}>指派人员</a><br />
          //                 <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 3, '退回')}>退回</a><br />
          //                 <a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 2, '废单')}>废单</a><br />
          //                 <a href="javascript:;" onClick={() => this.showInputTextModal(true, record, 10, '备注')}>备注</a><br />
          //               </div>
          //             </div>
          //           </a>
          //         </div>
          //       )
          //     } else {
          //       html = (
          //         <div class="row-operator">
          //           <a class="btnmore" href="javascript:;">...
          //             <div class="czbtns">
          //               <div class="santop"></div>
          //               <div class="czdiv">
          //                 <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //                 <a href="javascript:;" onClick={() => this.showModal(true, record, 2)}>修改</a><br />
          //                 <a href="javascript:;" class="red" onClick={() => this.handleperDialog(true, record)}>指派人员</a><br />
          //                 <a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 2, '废单')}>废单</a><br />
          //                 <a href="javascript:;" onClick={() => this.showInputTextModal(true, record, 10, '备注')}>备注</a>
          //               </div>
          //             </div>
          //           </a>
          //         </div>
          //       )
          //     }
          //       // 曾经完成
          //   } else if (record.dqzt === '9') {
          //     // 待处理
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 5, '接单')}>接单</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 2, '废单')}>废单</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 4, '撤回')}>撤回</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 3, '退回')}>退回</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   } else if (record.dqzt === '2') {
          //     // 处理中
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //               {record.sfzb === '0' ? <div><a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 6, '结单')}>结单</a></div>
          //                 : <div><a href="javascript:;" class="red" onClick={() => this.transferModal(record)}>结单</a></div>}
          //               <a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 2, '废单')}>废单</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 4, '撤回')}>撤回</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 3, '退回')}>退回</a><br />
          //               <a href="javascript:;" onClick={() => this.showInputTextModal(true, record, 9, '延单')}>延单</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   } else if (record.dqzt === '4') {
          //     // 维修完成
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.handleMaterialRegister(record, 1)}>耗材登记</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   } else if (record.dqzt === '10') {
          //     // 已登记耗材
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.handleMaterialRegister(record, 2)}>查看耗材</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   } else {
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   }
          // } else if (roleCode === 'BXXT_HQCGLY') {
          //   // 后勤管理员
          //   if (record.dqzt === '6') {
          //     // 废单审核
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 11, '废单审核')}>审核</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   } else if (record.dqzt === '10') {
          //     // 已登记耗材
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.handleMaterialRegister(record, 2)}>查看耗材</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   } else if (record.dqzt === '11') {
          //     // 延单审核中
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 2, '废单')}>废单</a><br />
          //               {record.sfzb === '0' ? <div><a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 6, '结单')}>结单</a></div>
          //                 : <div><a href="javascript:;" class="red" onClick={() => this.transferModal(record)}>结单</a></div>}
          //               <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 3, '退回')}>退回</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.delayModal(record)}>延单审核</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   } else if (record.dqzt === '8') {
          //     // 已延单
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //               <a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 2, '废单')}>废单</a><br />
          //               {record.sfzb === '0' ? <div><a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 6, '结单')}>结单</a></div>
          //                 : <div><a href="javascript:;" class="red" onClick={() => this.transferModal(record)}>结单</a></div>}
          //               <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 3, '退回')}>退回</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   } else {
          //     html = (
          //       <div class="row-operator">
          //         <a class="btnmore" href="javascript:;">...
          //           <div class="czbtns">
          //             <div class="santop"></div>
          //             <div class="czdiv">
          //               <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
          //             </div>
          //           </div>
          //         </a>
          //       </div>
          //     )
          //   }
          // }
          if (roleCode === 'BXXT_WXY' || roleCode === 'BXXT_WXJL') {
            // 维修员
            if (record.dqzt === '9') {
              // 待处理
              html = (
                <div class="row-operator">
                  <a class="btnmore" href="javascript:;">...
                    <div class="czbtns">
                      <div class="santop"></div>
                      <div class="czdiv">
                        <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
                        <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 5, '接单')}>接单</a><br />
                        <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 3, '退回')}>退回</a><br />
                      </div>
                    </div>
                  </a>
                </div>
              )
            } else if (record.dqzt === '2') {
              // 处理中
              html = (
                <div class="row-operator">
                  <a class="btnmore" href="javascript:;">...
                    <div class="czbtns">
                      <div class="santop"></div>
                      <div class="czdiv">
                        <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
                        {record.sfzb === '0' ? <div><a href="javascript:;" class="red" onClick={() => this.showInputTextModal(true, record, 6, '结单')}>结单</a></div>
                          : <div><a href="javascript:;" class="red" onClick={() => this.transferModal(record)}>结单</a></div>}
                        <a href="javascript:;" class="red" onClick={() => this.handleDialog(record, 3, '退回')}>退回</a><br />
                        <a href="javascript:;" onClick={() => this.showInputTextModal(true, record, 9, '延单')}>延单</a><br />
                        {record.sfzlxbx !== '1' && <div><a href="javascript:;" class="red" onClick={() => this.handleToLxbx(record)}>转为零星报修</a></div>}
                      </div>
                    </div>
                  </a>
                </div>
              )
            } else if (record.dqzt === '4') {
              // 维修完成
              html = (
                <div class="row-operator">
                  <a class="btnmore" href="javascript:;">...
                    <div class="czbtns">
                      <div class="santop"></div>
                      <div class="czdiv">
                        <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
                      </div>
                    </div>
                  </a>
                </div>
              )
            } else {
              html = (
                <div class="row-operator">
                  <a class="btnmore" href="javascript:;">...
                    <div class="czbtns">
                      <div class="santop"></div>
                      <div class="czdiv">
                        <a href="javascript:;" onClick={() => this.showModal(true, record, 1)}>查看</a><br />
                      </div>
                    </div>
                  </a>
                </div>
              )
            }
          }
          return html
        }
      }
    ]
    return {
      searchForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      overform: this.$form.createForm(this),
      Delayform: this.$form.createForm(this),
      transferform: this.$form.createForm(this),
      assignform: this.$form.createForm(this),
      usedform: this.$form.createForm(this),
      lxbxform: this.$form.createForm(this),
      typeData: [
        { text: '0', value: '', displayText: '全部' },
        { text: '1', value: '', displayText: '未接单' },
        { text: '9', value: '', displayText: '待处理' },
        { text: '2', value: '', displayText: '处理中' },
        { text: '3', value: '', displayText: '待确认' },
        { text: '4', value: '', displayText: '维修完成' },
        // { text: '10', value: '', displayText: '已登记耗材' },
        { text: '5', value: '', displayText: '已取消' },
        { text: '6', value: '', displayText: '废单审核中' },
        { text: '7', value: '', displayText: '已废单' },
        { text: '11', value: '', displayText: '延单审核中' },
        { text: '8', value: '', displayText: '已延单' }
      ],
      pdytypeData: [
        { text: '0', value: '', displayText: '全部' },
        { text: '1', value: '', displayText: '未接单' },
        { text: '9', value: '', displayText: '待处理' },
        { text: '2', value: '', displayText: '处理中' },
        { text: '3', value: '', displayText: '待确认' },
        { text: '4', value: '', displayText: '维修完成' },
        // { text: '10', value: '', displayText: '已登记耗材' },
        { text: '5', value: '', displayText: '已取消' },
        { text: '6', value: '', displayText: '废单审核中' },
        { text: '7', value: '', displayText: '已废单' },
        { text: '11', value: '', displayText: '延单审核中' },
        { text: '8', value: '', displayText: '已延单' }
      ],
      wxytypeData: [
        { text: '0', value: '', displayText: '全部' },
        { text: '9', value: '', displayText: '待处理' },
        { text: '2', value: '', displayText: '处理中' },
        { text: '3', value: '', displayText: '待确认' },
        { text: '4', value: '', displayText: '维修完成' },
        // { text: '10', value: '', displayText: '已登记耗材' },
        { text: '7', value: '', displayText: '已废单' },
        { text: '11', value: '', displayText: '延单审核中' },
        { text: '8', value: '', displayText: '已延单' }
      ],
      glytypeData: [
        { text: '0', value: '', displayText: '全部' },
        { text: '6', value: '', displayText: '废单审核中' },
        { text: '7', value: '', displayText: '已废单' },
        { text: '1', value: '', displayText: '未接单' },
        { text: '9', value: '', displayText: '待处理' },
        { text: '2', value: '', displayText: '处理中' },
        { text: '3', value: '', displayText: '待确认' },
        { text: '4', value: '', displayText: '维修完成' },
        // { text: '10', value: '', displayText: '已登记耗材' },
        { text: '5', value: '', displayText: '已取消' },
        { text: '11', value: '', displayText: '延单审核中' },
        { text: '8', value: '', displayText: '已延单' }
      ],
      operTypeHtml: [],
      // pagination: {
      //   total: 0,
      //   pageNum: 1,
      //   pageSize: 10
      // },
      topNavactive: 0,
      dateFormat: 'YYYY-MM-DD',
      query,
      columns,
      dataSource: [],
      selectedRows: [],
      visible: false,
      overVisible: false,
      uploadPicVisible: false,
      auditResultVisible: false,
      DelayVisible: false,
      transferVisiable: false,
      visibleprease: false,
      currentRowStatusText: '',
      preaseData: {},
      current: {},
      bxxqOptions: [],
      djhcOptions: [{
        label: '否',
        value: '0'
      }, {
        label: '是',
        value: '1'
      }],
      bxrlxOptions: [
        { label: '学生', value: '1' },
        { value: '2', label: '教职工' },
        { value: '3', label: '其它' }
      ],
      bxlxOptions: [],
      Treevalue: [],
      treeData: [],
      SHOW_PARENT,
      roleCode: '',
      ckeckList: [],
      startTime: '',
      endTime: '',
      shjgradio: '',
      xbradio: '',
      xqradio: '',
      scgzCheck: [],
      currentOper: '',

      // 上传
      previewVisible: false,
      previewImage: '',
      fileList: [],
      // 时间选择
      open: false,
      open2: false,
      f_eq_dqzt: '',
      formtitle: '',
      // 指派人员
      assignVisible: false,
      perdatasource: [],
      bxdh: '',
      zprxm: '',
      searchzprxm: '',
      zprdata: {},
      isActive: -1,
      isActivetwo: -1,
      // 耗材登记
      usedVisible: false,
      usedinfo: [],
      hcdjlist: [{}],
      data: [],
      MCdata: [],
      hcenabel: false,
      // 查看、修改报修单
      enableedit: false,
      username: '',
      schoolData: [{
        label: '文津校区',
        value: '01'
      }, {
        label: '新芜校区',
        value: '02'
      }],
      buildData: [],
      roomData: [],
      otypeData: [],
      typetwoData: [],
      typethirData: [],
      timestart: [],
      timeend: [],
      // schoolDatamod: '',
      // buildDatamod: '',
      // roomDatamod: '',
      // typeDatamod: '',
      typetwoDatamod: '',
      typethirDatamod: '',
      timestartmod: '',
      timeendmod: '',
      bxbzList: [],
      complete: '',
      fwpjradio: '',
      serviceModel: false,
      dllx: '',
      dataSourcePrint: [],
      noteXq: '',
      XqIndex: '',
      // 延单信息
      ydinfo: {},
      // 维修人员下拉
      wxryOptions: [],
      sfzbvalue: '0',
      // 转为零星报修
      lxbxVisible: false,
      gysList: []
    }
  },
  mounted () {
    this.fetchList(this.getFetchParams())
    // 获取报修学区下拉
    this.schoolArea()
    // 获取报修类型下拉
    this.bxlxSelect()
    this.getWxry()
  },
  methods: {
    getWxry () {
      this.$axios.post('/api/common/getRyxxByLx.do', { rylx: 5 }).then(res => {
        this.wxryOptions = res.data.list || []
      })
    },
    // 时间选择框
    handleOpenChange (open) {
      // console.log('open', open)
      this.open = open
    },
    handleClose () {
      this.open = false
      this.open2 = false
    },
    // 获取时间
    onpickerChange (date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
    },
    // 获取列表
    fetchList (params) {
      if (this.query.startTime && this.query.startTime) {
        this.startTime = this.query.startTime
        this.endTime = this.query.endTime
      }
      if (this.query.wxyname) {
        params.f_eq_bxjl__xqdm = this.query.schoolCode
      }
      if (this.query.wxyname) {
        params.f_like_wxryXm = this.query.wxyname
      }
      if (this.query.wxyname) {
        this.searchForm.setFieldsValue({ f_like_wxryXm: this.query.wxyname })
      }
      if (this.query.type && this.query.type !== '') {
        this.f_eq_dqzt = this.query.type
        this.topNavactive = this.query.type
      }

      if (this.f_eq_dqzt && this.f_eq_dqzt !== '' && this.f_eq_dqzt !== '0') {
        params.f_eq_dqzt = this.f_eq_dqzt
        // this.f_eq_dqzt = ''
      }
      if (params.f_eq_dqzt === '0') {
        params.f_eq_dqzt = ''
      }
      params.f_date_ge_bxjl__create_Date = this.startTime
      params.f_date_le_bxjl__create_Date = this.endTime
      params.s_bxjl__create_Date = 'desc'
      params.currentPageNo = params.pageNum
      params.pickerdate = []
      this.$axios.post('/api/bxgl/queryBxjlPage.do', params).then(res => {
        var dataone = res.data.list
        this.roleCode = res.data.roleCode
        if (this.roleCode === 'BXXT_HQCGLY') {
          this.typeData = this.glytypeData
        } else if (this.roleCode === 'BXXT_WXY' || this.roleCode === 'BXXT_WXJL') {
          this.typeData = this.wxytypeData
        } else if (this.roleCode === 'BXXT_PDY') {
          this.typeData = this.pdytypeData
        }
        var datatwo = this.typeData
        var allCount = 0
        for (var i = 0; i < datatwo.length; i++) {
          var isMatch = false
          var displayValue = 0
          for (var j = 0; j < dataone.length; j++) {
            if (dataone[j][0] === datatwo[i].text) {
              displayValue = dataone[j][1]
              allCount += dataone[j][1]
              isMatch = true
              // this.typeData[i].value = dataone[j][1]
            }
          }
          if (isMatch) {
            datatwo[i].value =
              datatwo[i].displayText + '(' + displayValue + ')'
          } else {
            datatwo[i].value = datatwo[i].value =
              datatwo[i].displayText + '(0)'
          }
        }
        datatwo[0].value = datatwo[0].displayText + '(' + allCount + ')'
        let rows = res.rows
        rows.forEach((item, index) => {
          item.key = index
        })
        this.dataSource = res.rows || []
        // 处理分页情况
        const { pageNum, pageSize } = params
        this.PAGINATION = {
          total: res.total || 0,
          pageNum,
          pageSize
        }
      })
    },
    // 搜索
    handleSearch (e) {
      e.preventDefault()
      let params = {
        ...this.getFetchParams({ pageNum: 1 }),
        f_eq_dqzt: this.f_eq_dqzt
      }
      // if (this.f_eq_dqzt === 0) {
      //   params = {
      //     ...this.getFetchParams({ pageNum: 1 })
      //   }
      // }
      this.fetchList(params)
    },
    handleSearchmore (value) {
      this.query.type = value.text
      this.topNavactive = value.text
      this.f_eq_dqzt = value.text
      let params = {
        ...this.getFetchParams({ pageNum: 1 }),
        f_eq_dqzt: this.f_eq_dqzt
      }
      this.fetchList(params)
    },
    onRowChange (selectedRows) {
      this.selectedRows = selectedRows
    },
    // 切换数据
    onChange (changeParams) {
      let params = {
        ...this.getFetchParams(changeParams),
        f_eq_dqzt: this.f_eq_dqzt
      }
      // this.selectedRows = []
      // if (this.f_eq_dqzt === 0) {
      //   params = {
      //     ...this.getFetchParams({ pageNum: 1 })
      //   }
      // }
      this.fetchList(params)
    },
    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...this.PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      return params
    },
    // 查看流程
    showFlowlabel (visible, record, text) {
      this.bxdh = record.bxdh
      this.currentRowStatusText = text
      this.$axios
        .post('/api/bxgl/queryBxlcByBxdh.do', {
          bxId: record.id,
          bxdh: record.bxdh
        })
        .then(res => {
          this.preaseData = res.data || []
          this.visibleprease = !!visible
        })
    },
    // 流程确定
    handleSubmitprease () {
      this.visibleprease = false
    },
    // 弹出显示输入框
    showInputTextModal (overVisible, record, type, displayText) {
      this.formtitle = displayText
      this.currentOper = type
      this.overVisible = !!overVisible
      this.current = record || {}
      if (type === 6) {
        this.uploadPicVisible = true
        this.enableedit = false
      } else {
        this.uploadPicVisible = false
      }
      if (type === 11) {
        this.auditResultVisible = true
      } else {
        this.auditResultVisible = false
      }
      // 编辑
      if (record) {
        this.$nextTick(() => {
          let fields = this.overform.getFieldsValue()
          for (var key in fields) {
            fields[key] = record[key]
          }
          this.overform.setFieldsValue(fields)
        })
      }
    },
    // 延单审核
    delayModal (record) {
      this.DelayVisible = true
      this.sfzbvalue = '0'
      this.current = record || {}
      this.$axios.post('/api/bxjl/getBxdXq.do', { bxdh: record.bxdh }).then(res => {
        this.ydinfo = res.data.data
        this.$nextTick(() => {
          this.Delayform.setFieldsValue({ sfzb: '0', shjg: '1' })
        })
      })
    },
    zhChange (e) {
      this.sfzbvalue = e.target.value
    },
    // 延单审核确定
    handleDelay () {
      var $this = this
      this.Delayform.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify($this.current) !== '{}') {
            values.bxdh = $this.current.bxdh
            values.cz = '12'
          }
          // 接口请求
          this.$axios.post('/api/bxgl/addLcbz.do', values).then(res => {
            this.$message.success('延单审核成功！')
            this.DelayVisible = false
            this.fetchList(this.getFetchParams({ pageNum: 1 }))
          })
        }
      })
    },
    // 结单
    transferModal (record) {
      this.current = record
      this.transferVisiable = true
    },
    // 已转办结单
    handletransfer () {
      var $this = this
      this.transferform.validateFields((err, values) => {
        if (!err) {
          if (JSON.stringify($this.current) !== '{}') {
            values.bxdh = $this.current.bxdh
            values.cz = '6'
          }
          // values.hcdjlist.map(item => {
          //   item.xqdm = '02'
          // })
          let lbflag = false
          values.hcdjlist.map(item => {
            if (((!item.hcId || item.hcId === '') && (item.hfsl && item.hfsl !== '')) || ((!item.hfsl || item.hfsl === '') && (item.hcId && item.hcId !== ''))) {
              lbflag = true
            }
          })
          if (lbflag) {
            this.$message.warn('请填写完整耗材信息')
            return false
          }
          values.hclb = JSON.stringify(values.hcdjlist)
          delete values.hcdjlist
          this.$axios.post('/api/bxgl/addLcbz.do', values).then(res => {
            this.$message.success(`结单成功！`)
            this.transferVisiable = false
            this.fetchList(this.getFetchParams())
          })
        }
      })
    },
    // 指派人员
    handleperDialog (visible, record) {
      // 重置指派人信息
      this.isActive = -1
      this.isActivetwo = -1
      this.zprdata = {}

      this.assignVisible = !!visible
      this.zprxm = ''
      this.searchzprxm = ''
      // 获取指派人员
      this.bxdh = record.bxdh
      this.getpersondata(record.bxdh, '')
    },
    getpersondata (bxdh, name) {
      this.$axios.post('/api/bxgl/queryWxryWwcCount.do', { bxdh: bxdh, xm: name }).then(res => {
        this.perdatasource = res.data
      })
    },
    // 指派人员搜索
    zprysearch () {
      // var name = this.zprxm
      this.zprxm = this.searchzprxm
      this.perdatasource = []
      this.getpersondata(this.bxdh, this.searchzprxm)
    },
    // 选择指派人员
    chosewxy (data, index, type) {
      if (type === 1) {
        this.isActive = index
        this.isActivetwo = -1
      } else {
        this.isActivetwo = index
        this.isActive = -1
      }
      this.zprdata = data
    },
    // 确定指派人员
    handleAssignption () {
      if (!this.zprdata.DDM) {
        this.$message.warning(`请选择指派人员！`)
        return false
      }
      let params = {
        bxdh: this.bxdh,
        cz: '1',
        wxry: this.zprdata.DDM
      }
      this.$axios.post('/api/bxgl/addLcbz.do', params).then(res => {
        if (res.flag) {
          this.$message.success(`维修单指派成功！`)
          this.assignVisible = false
          this.fetchList(this.getFetchParams())
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 耗材登记
    handleMaterialRegister (record, type) {
      this.usedVisible = true
      // this.schoolList()
      this.usedinfo = record
      this.hcdjlist = [{}]
      this.noteXq = ''
      // this.data = []
      this.fetch()
      if (type === 2) { // 查看
        this.hcenabel = true
        this.schoolData = [{
          label: '文津校区',
          value: '01'
        }, {
          label: '新芜校区',
          value: '02'
        }]
      } else { // 编辑
        this.hcenabel = false
        this.schoolData = [{
          label: '新芜校区',
          value: '02'
        }]
      }
      this.$axios.post('/api/hcgl/queryHclbByBxdh.do', { bxdh: record.id }).then(res => {
        for (let i = 1; i < res.data.list.length; i++) {
          this.hcdjlist.push({})
        }
        this.$nextTick(() => {
          if (res.data.list.length > 0) {
            let fields = this.usedform.getFieldsValue()
            for (let j = 0; j < fields.hcdjlist.length; j++) {
              fields.hcdjlist[j]['xqdm'] = res.data.list[j]['activeFlag'] || '02'
              fields.hcdjlist[j]['hcId'] = res.data.list[j]['hcId']
              fields.hcdjlist[j]['hfsl'] = res.data.list[j]['hfsl']
            }
            this.usedform.setFieldsValue(fields)
          }
        })
      })
    },
    // 添加耗材及数量
    addList () {
      this.hcdjlist.push({})
    },
    // 耗材下拉数据
    fetch (value, callback) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      currentValue = value
      let self = this
      function fake () {
        self.$axios.post('/api/hcgl/queryHcList.do', { f_like_mc: value, f_eq_xqdm: self.noteXq || '02' }).then(res => {
          if (currentValue === value) {
            const result = res.data.list
            let newdata = self.MCdata
            if (result.length > 0) {
              if (newdata.length === 0) {
                newdata.push({
                  id: result[0].id,
                  mc: result[0].mc
                })
              }
              result.forEach(itemtwo => {
                let fullnum = 0
                newdata.forEach(item => {
                  if (item.id === itemtwo.id) { // 对象里的唯一标识id
                    fullnum++
                  }
                })
                if (fullnum === 0) {
                  newdata.push({
                    id: itemtwo.id,
                    mc: itemtwo.mc
                  })
                }
              })
              self.MCdata = newdata
            }
            self.data = result
          }
        })
      }
      timeout = setTimeout(fake, 500)
    },
    // 校区改变
    handleChangeXq (index) {
      let fields = this.usedform.getFieldsValue()
      fields.hcdjlist[index].hcId = undefined
      this.usedform.setFieldsValue(fields)
    },
    handleFocus (index) {
      this.data = []
      this.XqIndex = index
    },
    // 耗材可输入下拉框
    handleSearchSelect (value) {
      let fields = this.usedform.getFieldsValue()
      let index = this.XqIndex
      let self = this
      if (timeoutTwo) {
        clearTimeout(timeoutTwo)
        timeoutTwo = null
      }

      if (fields.hcdjlist[index].xqdm) {
        this.noteXq = fields.hcdjlist[index].xqdm
        this.fetch(value)
      } else {
        timeoutTwo = setTimeout(fakes, 1000)
      }
      function fakes () {
        self.$message.warning('请先选择对应行的校区！')
      }
    },
    // 耗材可输入下拉框
    handleSearchSelect2 (value) {
      this.fetch(value)
    },
    handleChange (value) {
      this.value = value
      this.fetch(value)
    },
    // 删除耗材及数量
    delList (index) {
      var $this = this
      this.$confirm({
        title: '提示',
        content: '确定删除该条数据？',
        okType: 'danger',
        onOk: () => {
          if (this.hcdjlist.length > 1) {
            // eslint-disable-next-line
            this.usedform.validateFields((err, values) => {
              this.hcdjlist.splice(index, 1)
              values.hcdjlist.splice(index, 1)
              $this.data = $this.MCdata
              this.usedform.setFieldsValue(values)
              this.$message.success(`删除成功！`)
            })
          } else {
            this.$message.warning(`至少保留一条数据！`)
          }
        }
      })
    },
    // 耗材登记取消
    canelusedption () {
      this.usedVisible = false
    },
    // 耗材登记确定、保存
    handleusedption (type) {
      this.usedform.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify(this.usedinfo) !== '{}') {
            values.bxdh = this.usedinfo.id
          }
          values.zt = type
          // 接口请求
          this.usedAjax(values)
        }
      })
    },
    // 耗材登记确定请求
    usedAjax (params) {
      params.hclb = JSON.stringify(params.hcdjlist)
      delete params.hcdjlist
      this.$axios.post('/api/hcgl/saveOrUpateHclb.do', params).then(res => {
        this.$message.success(`${params.zt === 1 ? ' 新增' : '保存'}成功！`)
        this.usedVisible = false
        this.fetchList(this.getFetchParams())
      })
    },
    // 我要报修
    toApply () {
      let routeuil = this.$router.resolve({
        path: '/apply',
        query: { bxtype: 2 }
      })
      window.open(routeuil.href, '_blank')
    },
    // 导出excel
    exportExcel (e) {
      e.preventDefault()
      let params = this.getFetchParams({ isRemove: true })
      if (this.f_eq_dqzt && this.f_eq_dqzt !== '' && this.f_eq_dqzt !== '0') {
        params.f_eq_dqzt = this.f_eq_dqzt
        params.dqzt = this.f_eq_dqzt
        // this.f_eq_dqzt = ''
      }
      if (params.f_eq_dqzt === '0') {
        params.f_eq_dqzt = ''
      }
      params.f_date_ge_bxjl__create_Date = this.startTime
      params.f_date_le_bxjl__create_Date = this.endTime
      params.ids = this.selectedRows.map(item => item.id).join(',')
      let url = env === 'production'
        ? '/bxgl/exportBxgl.do'
        : '/api/bxgl/exportBxgl.do'
      this.epxportway(url, params)
    },
    // 导出方法
    epxportway (url, data) {
      if (url && data) {
        var form = window.$('<form></form>')
        form.attr('action', url)
        form.attr('method', 'post')
        for (var item in data) {
          var input = window.$('<input type="text" />')
          input.attr('name', item)
          input.attr('value', data[item])
          form.append(input)
        }
        form
          .appendTo('body')
          .submit()
          .remove()
      }
    },
    // 打印
    printIng () {
      // eslint-disable-next-line
      let params = ''
      if (this.selectedRows && this.selectedRows.length > 0) {
        params = this.selectedRows.map(item => item.id).join(',')
        this.dataSourcePrint = this.selectedRows
      } else {
        this.$message.error('请勾选需要打印的数据')
        return false
      }
      // eslint-disable-next-line
      $('.print-area').css('display', 'block');
      setTimeout(() => {
        window.print()
        // eslint-disable-next-line
        $('.print-area').css('display', 'none');
      }, 50)

      // let url = env === 'production'
      //   ? '/file/docDownload.do?ids=' + params
      //   : '/api/file/docDownload.do?ids=' + params
      // window.location.href = url
    },
    // 提交带说明的动作 延单、结单、备注、废单
    handleDescription () {
      var $this = this
      this.overform.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify($this.current) !== '{}') {
            values.id = $this.current.id
            values.bxdh = $this.current.bxdh
            values.cz = $this.currentOper
          }
          let ids = []
          if (values.imgUrl) {
            ids = values.imgUrl.map(item => item.id)
          }
          values.jdPicIds = ids.join(',')
          values.shjg = $this.shjgradio
          // 接口请求
          this.descriptionAjax(values)
        }
      })
    },
    // 提交带说明的动作 延单、结单、备注、废单请求
    descriptionAjax (params) {
      this.$axios.post('/api/bxgl/addLcbz.do', params).then(res => {
        this.$message.success(this.formtitle + '成功！')
        this.overVisible = false
        this.fetchList(this.getFetchParams({ pageNum: 1 }))
      })
    },
    // 公共确认窗口处理
    handleDialog (record, type, hintText) {
      this.$confirm({
        title: hintText,
        content: '您是否要进行该操作？',
        okType: 'danger',
        onOk: () => {
          // 请求
          this.commonDialogAjax({ bxdh: record.bxdh, cz: type }, hintText)
        }
      })
    },
    // 转为零星报修
    handleToLxbx (record) {
      this.current = record
      this.$axios.post('/api/gysgl/allList.do').then(res => {
        this.gysList = (res.data && res.data.list) || []
        this.lxbxVisible = true
      })
    },
    // 转为零星报修提交
    handleLxbxSubmit () {
      this.lxbxform.validateFields((err, values) => {
        if (!err) {
          this.$axios.post('/api/bxjl/confirmToLxbx.do', {
            bxjlId: this.current.id,
            gysId: values.gysId
          }).then(res => {
            if (res.flag) {
              this.$message.success('转换成功！')
              this.lxbxVisible = false
              this.fetchList(this.getFetchParams())
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          })
        }
      })
    },
    // 供应商下拉搜索过滤
    filterGys (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 公共确认窗口处理请求
    commonDialogAjax (params, hintText) {
      this.$axios.post('/api/bxgl/addLcbz.do', params).then(res => {
        if (res.flag) {
          this.$message.success(hintText + `成功！`)
          this.fetchList(this.getFetchParams({ isRemove: true }))
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取学区下拉
    schoolArea () {
      this.$axios.post('/api/dict/getXqInfo.do').then(res => {
        this.bxxqOptions = res.data.data || []
        this.$nextTick(() => {
          if (this.query) {
            let date = []
            if (this.query.startTime && this.query.endTime) {
              date = [
                moment(this.query.startTime, this.dateFormat),
                moment(this.query.endTime, this.dateFormat)
              ]
            }
            this.searchForm.setFieldsValue({
              f_eq_bxjl__xqdm: this.query.schoolCode,
              pickerdate: date
            })
          }
        })
      })
    },

    // 获取报修类型下拉
    bxlxSelect () {
      this.$axios.post('/api/bxjl/getBxlx.do', { cj: 1 }).then(res => {
        this.bxlxOptions = res.data.data || []
      })
    },
    // 树选择
    onChangeTree (value) {
      this.Treevalue = value
    },
    // 多选
    onckeckChange (checkedValues) {
      this.scgzCheck = checkedValues
    },
    // 审核结果单选
    onShjgChange (checkedValues) {
      this.shjgradio = checkedValues.target.value
    },
    // 校区单选
    onxqChange (checkedValues) {
      this.xqradio = checkedValues.target.value
    },
    // 性别单选
    onxbChange (checkedValues) {
      this.xbradio = checkedValues.target.value
    },

    // 1：查看  2：修改
    showModal (visible, record, type) {
      this.visible = !!visible
      this.current = record || {}
      if (type === 1) {
        this.enableedit = true
        this.$nextTick(function () {
          window.$('.ant-modal-content .ant-modal-footer').css('display', 'none')
        })
      } else {
        this.enableedit = false
      }
      // 获取订单信息
      this.$axios.post('/api/bxjl/getBxdXq.do', { bxdh: record.bxdh }).then(res => {
        var values = res.data.data
        // 获取楼栋下拉
        this.buildList(values.xqdm)
        // 获取房间下拉
        this.roomList(values.lyId)
        this.$nextTick(() => {
          let fields = this.form.getFieldsValue()
          for (var key in fields) {
            fields[key] = values[key]
          }
          // 报修类型
          if (values.bxlxList) {
            this.typetwoDatamod = ''
            this.typethirDatamod = ''
            for (var i = 0; i < values.bxlxList.length; i++) {
              if (values.bxlxList[i].cj === '1') {
                fields.bxlx = values.bxlxList[i].id
                // this.typeDatamod = values.bxlxList[i].id
                this.typetwoList(values.bxlxList[i].id)
              } else if (values.bxlxList[i].cj === '2') {
                this.typetwoDatamod = values.bxlxList[i].id
                this.typethirList(values.bxlxList[i].id)
              } else {
                this.typethirDatamod = values.bxlxList[i].id
              }
            }
          }
          fields.yjfk = values.yjfk
          fields.qyfjh = values.qyfjhId
          fields.imgUrl = values.fileList
          // this.schoolDatamod = values.xqdm
          // this.buildDatamod = values.lyId
          // this.roomDatamod = values.qyfjhId
          this.dllx = values.dllx
          this.username = values.xm
          this.timestartmod = values.kssj
          this.timeendmod = values.jssj
          this.bxbzList = values.bxbzList
          this.fwpjradio = values.fwpj
          this.complete = values.wcqk

          if (values.wcqk !== '' && type === 1 && values.fwly !== '3') {
            this.serviceModel = true
          } else {
            this.serviceModel = false
          }
          this.$nextTick(function () {
            this.form.setFieldsValue(fields)
          })
        })
      })
      // // 获取校区
      // this.schoolList()
      // 获取报修类型
      this.typeList()
      // 特殊时间
      this.specailtime()
    },
    // 关闭查看
    cleanform () {
      this.visible = false
      this.enableedit = false
    },
    // schoolList () {
    //   this.$axios.post('/api/dict/getXqInfo.do').then(res => {
    //     this.schoolData = res.data.data || []
    //   })
    // },
    // 学校change
    handleSchoolChange (value) {
      this.form.setFieldsValue({ lyId: '', qyfjh: '' })
      this.buildList(value)
    },
    buildList (id) {
      this.$axios.post('/api/bxjl/getBxdd.do', { xqdm: id }).then(res => {
        this.buildData = res.data.data || []
      })
    },
    // 楼宇change
    handleBuildChange (value) {
      this.form.setFieldsValue({ qyfjh: '' })
      this.roomList(value)
    },
    roomList (name) {
      this.$axios.post('/api/bxjl/getBxdd.do', { lyId: name }).then(res => {
        this.roomData = res.data.data || []
      })
    },
    typeList () {
      this.$axios.post('/api/bxjl/getBxlx.do', { cj: 1 }).then(res => {
        this.otypeData = res.data.data || []
      })
    },
    // 报修类型
    handletypeChange (value) {
      this.typetwoList(value)
      this.typetwoDatamod = ''
      this.typethirDatamod = ''
    },
    typetwoList (id) {
      this.$axios.post('/api/bxjl/getBxlx.do', { cj: 2, pId: id }).then(res => {
        this.typetwoData = res.data.data || []
      })
    },
    // 报修类型two
    handletypetwoChange (value) {
      this.typethirList(value)
      this.typethirDatamod = ''
    },
    typethirList (id) {
      this.$axios.post('/api/bxjl/getBxlx.do', { cj: 3, pId: id }).then(res => {
        this.typethirData = res.data.data || []
      })
    },
    // 特殊时间
    specailtime () {
      this.$axios
        .post('/api/dict/getDictListByTypeId.do', {
          typeId: '8aa867c76a2918b0016a2918ccbe0000'
        })
        .then(res => {
          this.timestart = res.data.data || []
          this.timeend = res.data.data || []
        })
    },
    // 新增、编辑 handleDescription
    handleSubmit (e) {
      e.preventDefault()
      let $this = this
      if (this.enableedit === true) {
        this.visible = false
      } else {
        this.form.validateFields((err, values) => {
          if (!err) {
            // 处理编辑时添加ID字段
            if (JSON.stringify($this.current) !== '{}') {
              values.id = $this.current.id
            }
            let ids = []
            if (values.imgUrl) {
              ids = values.imgUrl.map(item => item.id)
            }
            values.tpId = ids.join(',')
            // values.xqdm = this.schoolDatamod
            // values.lyId = this.buildDatamod
            // values.qyfjh = this.roomDatamod
            values.xm = this.username
            if (this.typethirDatamod) {
              values.bxlx = this.typethirDatamod
            } else if (this.typetwoDatamod) {
              values.bxlx = this.typetwoDatamod
            }
            values.dllx = this.dllx
            values.kssj = this.timestartmod
            values.jssj = this.timeendmod
            values.type = '1'
            // 接口请求
            this.submitAjax(values)
          }
        })
      }
      this.enableedit = false
    },
    // 新增、编辑请求
    submitAjax (params) {
      this.$axios.post('/api/bxgl/saveOrUpdateBxd.do', params).then(res => {
        if (res.flag) {
          this.$message.success('修改成功！')
          setTimeout(() => {
            this.fetchList(this.getFetchParams({ pageNum: 1 }))
            this.visible = false
          }, 1000)
        }
      })
    },
    // 指派人员未完成
    jumptodetail (data) {
      let routeData = this.$router.resolve({
        path: '/repair',
        query: { wxyname: data.XM }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style>
.table-operator {
  text-align: right;
  /* margin-bottom: 15px; */
}
.table-operator :last-child {
  margin-right: 0;
}
.a-button-selected {
  text-decoration: none;
  color: #40a9ff;
  background-color: #fff;
  border-color: #40a9ff;
  outline: 0;
}
.a-button-selected[disabled],
.a-button-selected[disabled]:hover {
  text-decoration: none;
  color: #40a9ff;
  background-color: #fff;
  border-color: #40a9ff;
  outline: 0;
}
a.red {
  color: red;
}
.lcmodal div {
  color: #999;
}
.lcmodal p {
  text-indent: 0;
  color: #333;
  margin-top: 8px;
  word-break: break-all;
}
.lcpicdiv img {
  width: 16%;
  height: 55px;
  margin-right: 2%;
  padding: 1%;
  border: 1px solid #e5e5e5;
}
.lcpicdiv :last-child {
  margin-right: 0;
}

.zprlistul li {
  margin-top: 10px;
  padding: 2px 10px;
}
.zprlistul li.active {
  background: #40a9ff;
}
.zprlistul li.active a {
  color: #fff;
}
.zprlistul a {
  float: right;
  margin-right: 20px;
}
.zprlistul .notice {
  margin-top: 10px;
  text-align: center;
}
.mydiyfooter {
  margin-top: 20px;
  text-align: center;
}
.mydiyfooter button {
  margin: 0 10px;
}
.addanddel .ant-btn {
  padding: 0;
  margin-top: 4px;
}
.ant-calendar-picker-input {
  padding-left: 5px;
  padding-right: 16px;
}
.ant-calendar-picker-clear,
.ant-calendar-picker-icon {
  right: 8px;
}
.ant-form-item-label label:after {
  content: " ";
}
.print-area {
  width: 100%;
}
.print-area .grid-table {
  padding: 0;
  vertical-align: top;
}
.ant-table-scroll {
  width: 100%;
  overflow-x: auto;
}
.ant-table-scroll>.ant-table-body{
  min-width: 1600px;
}
.grid-table .table-inline {
  vertical-align: top;
  display: inline-block;
  width: 49%;
}
.ant-table-fixed-right {
  overflow: initial!important;
}
.grid-table .table-inline.left {
  margin-right: 1%;
}
.grid-table .table-inline.right {
  margin-left: 1%;
}
.grid-table table {
  width: 100%;
  margin-top: 15px;
}
.grid-table td {
  width: 22%;
  text-align: center;
}
.grid-table th {
  width: 28%;
  text-align: left;
  font-weight: normal;
}
.grid-table th,
.grid-table td {
  font-size: 12px;
  border: 1px solid #e8e8e8;
  word-break: break-all;
  padding: 3px 0;
}
.title-border-left {
  border-left: 3px solid rgb(48, 148, 249);
  padding-left: 29px;
  height: 18px;
  line-height: 18px;
  font-size: 16px;
  font-weight:bold;
  margin-bottom: 6px;
}
/* .ant-table td {
  white-space: nowrap;
} */
</style>
